
import React from 'react';
import { Check } from 'lucide-react';

const AdvisoryValueProposition = () => {
  return (
    <section className="py-16 md:py-20 bg-background border-t border-white/10">
      <div className="container mx-auto px-6">
        <div className="md:flex md:gap-16">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Move Fast. Stay Safe. <br/>Stay Competitive
            </h2>
            
            <p className="text-white/80 mb-4">
              We're a boutique team of legal technology experts — here to support your leadership with clarity, expertise, and actionable next steps — never theory or guesswork.
            </p>
            
            <p className="text-white/80 mb-6">
              At DocketLabs, we act as your practical expert ally, providing real-world guidance that helps you move faster, minimize risk, compete harder, and protect your client relationships. Our flexible advisory options help you strengthen your firm's position today — and build lasting competitive advantage for tomorrow.
            </p>
          </div>
          
          <div className="md:w-1/2">
            <div className="space-y-5">
              <div className="flex gap-4">
                <div className="flex-shrink-0 mt-1">
                  <Check className="h-5 w-5 text-green-500" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-1">Speed</h3>
                  <p className="text-white/70">Act on opportunities faster than slower-moving firms.</p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <div className="flex-shrink-0 mt-1">
                  <Check className="h-5 w-5 text-green-500" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-1">Safety</h3>
                  <p className="text-white/70">Avoid costly mistakes with expert guidance on compliance, ethics, and client trust.</p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <div className="flex-shrink-0 mt-1">
                  <Check className="h-5 w-5 text-green-500" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-1">Clarity</h3>
                  <p className="text-white/70">Get direct, actionable advice — no jargon, no guesswork.</p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <div className="flex-shrink-0 mt-1">
                  <Check className="h-5 w-5 text-green-500" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-1">Flexibility</h3>
                  <p className="text-white/70">Book a single session or build an ongoing partnership — scale support to your firm's needs and goals.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvisoryValueProposition;
